<template>
  <div class="pageContent" v-if="isPhone">
    <div class="title">输入手机号绑定数字影像</div>
    <div class="bindDetails">
      <div class="IDNumber">
        <van-field
          style="margin-top:20px"
          v-model="phone"
          placeholder="请输入手机号"
          @input.native="phoneFn"
        />
      </div>
      <div class="code">
        <van-field
          class="codeInput"
          v-model="phoneCode"
          type="number"
          placeholder="请输入4位验证码"
          @input.native="onInputCode"
          maxlength="4"
        />
        <van-button
          class="toObtain"
          :disabled="codeBool"
          @click.native="getsendSms"
          type="default"
          >{{ innerText }}</van-button
        >
      </div>

      <footer class="footer">
        <van-button
          type="primary"
          :disabled="rules"
          @click.native="getCheckCaptcha"
          >下一步</van-button
        >
      </footer>
    </div>
  </div>
  <div class="pageContent" v-else>
    <!-- <img src="../../assets/login.png" alt="Login logo" class="loginLogo" /> -->
    <div class="title" v-if="isNum">输入身份证号/门诊号/住院号绑定数字影像</div>
    <div class="title" v-else>输入身份证号绑定数字影像</div>
    <div class="bindDetails">
      <div class="IDNumber">
        <van-field
          v-model="IDNumber"
          placeholder="请输入身份证号"
          maxlength="18"
          @input.native="onIdNumber"
        />
        <!-- <van-field
          style="margin-top:20px"
          v-model="name"
          placeholder="请输入姓名"
          @input.native="nameFN"
          v-if="isName"
        /> -->
        <van-field
          style="margin-top:20px"
          v-model="hospitalNum"
          placeholder="请输入门诊号或住院号"
          @input.native="hospitalNumFn"
          v-if="isNum"
        />
      </div>
      <footer class="footer">
        <van-button type="primary" :disabled="rules" @click.native="nextFn"
          >下一步</van-button
        >
      </footer>
    </div>
  </div>
</template>
<script>
import { bind, dockSendSms, dockCheckCaptcha } from "@/api/login";
import Storage from "@/tools/storage";
export default {
  name: "checkInfoOuter",
  data() {
    return {
      IDNumber: "",
      name: "",
      hospitalNum: "",
      rules: true,
      isName: false,
      isNum: false,
      isPhone: false,
      phone: "",
      phoneCode: "",
      codeBool: true,
      innerText: "获取验证码",
    };
  },
  methods: {
    onIdNumber() {
      let institution_id = window.location.href.split("/checkInfoOuter/")[1];
      if (institution_id == "27400005") {
        if (this.IDNumber.length == 18) {
          this.rules = false;
          return;
        }
        this.rules = true;
      } else if (institution_id == "25500004") {
        if (this.hospitalNum || this.IDNumber.length == 18) {
          this.rules = false;
          return;
        }
        this.rules = true;
      }
    },
    nameFN() {
      if (this.name && this.IDNumber.length == 18) {
        this.rules = false;
        return;
      }
      this.rules = true;
    },
    phoneFn() {
      if (this.phone && /^1[3|4|5|7|8][0-9]{9}$/.test(this.phone)) {
        this.codeBool = false;
        return;
      } else {
        this.codeBool = true;
      }
    },
    onInputCode() {
      if (this.phoneCode.length == 4 && this.phone) {
        this.rules = false;
      } else {
        this.rules = true;
      }
    },
    async getsendSms() {
      this.djsFn();
      let data = { phone: this.phone };
      let res = await dockSendSms(data);
    },
    djsFn() {
      let timer = null;
      clearInterval(timer); //这句话至关重要
      let time = 60;
      let that = this;
      timer = setInterval(function() {
        if (time <= 0) {
          that.innerText = "";
          that.innerText = "重新获取";
          that.codeBool = false;
          clearInterval(timer);
        } else {
          that.codeBool = true;
          that.innerText = "";
          that.innerText = "剩余时间" + time + "秒";
          time--;
        }
      }, 1000);
    },
    async getCheckCaptcha() {
      let data = {
        phone: this.phone,
        code: this.phoneCode,
      };
      let res = await dockCheckCaptcha(data);
      if (res) {
        this.nextFn();
      }
    },
    hospitalNumFn() {
      if (this.hospitalNum || this.IDNumber.length == 18) {
        this.rules = false;
        return;
      }
      this.rules = true;
    },
    nextFn() {
      let institution_id = window.location.href.split("/checkInfoOuter/")[1];
      window.localStorage.setItem("IDNumber", this.IDNumber);
      // window.localStorage.setItem("name", this.name);
      window.localStorage.setItem("hospitalNum", this.hospitalNum);
      console.log(institution_id);
      window.localStorage.setItem("institution_id", institution_id);
      window.localStorage.setItem("phone", this.phone);
      // Storage.set('IDNumber', this.IDNumber)
      this.$router.push({
        path: "/reportListOuter",
      });
    },
  },
  created() {
    window.localStorage.clear();
    let institution_id = window.location.href.split("/checkInfoOuter/")[1];
    if (institution_id == "41000009") {
      this.isPhone = true;
    } else {
      this.isPhone = false;
      if (institution_id == "27400005") {
        this.isName = false;
      }
      if (institution_id == "25500004") {
        this.isNum = true;
      }
    }
    if (window.localStorage.getItem("IDNumber")) {
      this.$router.push({
        path: "/reportListOuter",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.title {
  width: 100%;
  padding: 65px 0 20px;
  font-size: 19px;
  font-weight: 800;
}
.pageContent img {
  width: 83px;
  height: 83px;
}
.pageContent .loginLogo {
  padding-top: 65px;
}
.bindDetails {
  width: 90%;
  margin: 0 auto;
}
.code {
  display: flex;
  margin-top: 20px;
}
.codeInput {
  width: 65%;
}
.toObtain {
  margin-left: 20px;
  color: rgb(19, 172, 193);
  font-size: 14px;
}
</style>
